module.exports = require("./el-CY.js");